<svelte:head>

    <title>Reset • keyosh</title>

</svelte:head>

<script>
    import Reset from "../components/reset.svelte"
</script>


<section>

    <Reset />

</section>


<style>

    section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

</style>
